import React from 'react';
import PropTypes from 'prop-types';
import SvgIcon from '@material-ui/core/SvgIcon';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styled from 'styled-components';

const StyledIcon = styled(SvgIcon)`
  && {
    &.icon-success {
      color: ${props => props.theme.palette.success.main};
    }
  }
`;

const Icon = ({ icon, size, fixedWidth, className, color, style }) => (
  <StyledIcon
    fontSize={size}
    className={className ? `${className} icon-${color}` : `icon-${color}`}
    style={style}
    color={color}
  >
    <FontAwesomeIcon icon={icon} fixedWidth={fixedWidth} />
  </StyledIcon>
);

Icon.propTypes = {
  color: PropTypes.oneOf([
    'action',
    'disabled',
    'error',
    'success',
    'inherit',
    'primary',
    'secondary',
  ]),
  icon: PropTypes.array.isRequired,
  size: PropTypes.oneOf(['small', 'large', 'default', 'inherit']),
  fixedWidth: PropTypes.bool,
  className: PropTypes.string,
  style: PropTypes.object,
};

Icon.defaultProps = {
  color: 'inherit',
  size: 'default',
  fixedWidth: true,
  className: null,
  style: null,
};

export default Icon;
